import { QueryClient } from "@tanstack/react-query";

interface MaybeCoded {
  code?: unknown;
  status?: unknown;
}

/** 42501 from RPCs/RLS or a 401/403 HTTP status: never retried, rendered as PermissionDenied. */
export function isAuthorizationError(error: unknown): boolean {
  if (typeof error !== "object" || error === null) return false;
  const e = error as MaybeCoded;
  return e.code === "42501" || e.status === 401 || e.status === 403;
}

export function createAppQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: (failureCount, error) => !isAuthorizationError(error) && failureCount < 2,
      },
    },
  });
}
